import React from "react";

import { ResourceCard, ResourceContainer } from "./index.style";

const Resources = () => {
  return (
    <ResourceContainer>
      <h2> Additional Resources </h2>
      <ResourceCard>
        <img src="https://picsum.photos/id/1/400" alt="resource1" />
        <h3> Find Talent with QuirkyCoders Resume </h3>
        <p>
          Learn how to use this powerful recruiting resource to reach the right
          talent.
        </p>
      </ResourceCard>
      <ResourceCard>
        <img src="https://picsum.photos/id/1/400" alt="resource2" />
        <h3>Advanced Resume Search Techniques</h3>
        <p>
          Take full advantage of QuirkyCoders Resume with advanced search
          techniques and features.
        </p>
      </ResourceCard>
    </ResourceContainer>
  );
};

export default Resources;

